import styled from 'styled-components';
import { colors } from '#styles.variables';

export const Filters = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 24px 0;
  label { display: flex; flex-direction: column; gap: 8px; color: ${colors.black._80}; }
  select { min-width: 200px; padding: 10px 12px; border: 1px solid ${colors.black._10}; border-radius: 6px; background: white; color: ${colors.black._100}; }
`;

export const RetryButton = styled.button`
  padding: 8px 12px;
  border: 0;
  border-radius: 6px;
  background: ${colors.primary._100};
  color: ${colors.secondary._100};
  cursor: pointer;
  white-space: nowrap;
  &:disabled { opacity: .5; cursor: default; }
`;
